import { apiClient, ConversationRequestRequest, ConversationResponse } from '../../../api/client';

export const getAssistantResponse = async (
  updatedMessages: { role: string; content: string }[]
): Promise<ConversationResponse> => {
  const conversation_language: string | null = localStorage.getItem('conversation_language');
  
  const payload: ConversationRequestRequest = {
    message_list: updatedMessages.slice(-5),
    conversation_language
  };
  
  const response = await apiClient.chat.chatConversationCreate(payload);
  return response.data;
};
